import Reveal from "./Reveal";
import useI18n from "@/i18n";

export default function Approche() {
    const { t } = useI18n();
    return (
        <section id="approche" className="grad-up scroll-mt-24 py-16 md:py-24" data-testid="approche-section">
            <div className="mx-auto max-w-[1080px] px-5">
                <Reveal>
                    <p className="eyebrow">{t.approche.eyebrow}</p>
                    <h2 className="max-w-[24ch] text-3xl text-terrat md:text-4xl">
                        {t.approche.h2}
                    </h2>
                    <hr className="rule-gold mt-4 w-16" />
                    <p className="mt-4 max-w-[54ch] text-lg text-ink2">{t.approche.lead}</p>
                    <div className="mt-5 max-w-[64ch] space-y-3 text-ink2" data-testid="approche-presentation">
                        {t.approche.paragraphes.map((p) => (
                            <p key={p.slice(0, 40)}>{p}</p>
                        ))}
                        <p className="font-semibold text-olivet">{t.approche.conclusion}</p>
                    </div>
                    <p className="mt-6 text-sm font-semibold text-olivet">{t.approche.prompt}</p>
                </Reveal>
                <div className="mt-6 grid gap-6 md:grid-cols-2">
                    {t.approche.items.map(([title, text], i) => (
                        <Reveal key={title} delay={i * 0.05}>
                            <div className="card h-full p-6">
                                <h3 className="font-sans text-lg font-bold text-olivet">{title}</h3>
                                <hr className="rule-gold mt-3 w-12" />
                                <p className="mt-3">{text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
